/* eslint-disable no-undef, prefer-rest-params */
class Admiral {
  constructor() {
    window.admiral =
      window.admiral ||
      function () {
        ;(admiral.q = admiral.q || []).push(arguments)
      }
    this.init()
  }

  init() {
    const { tags = '' } = window.golfAds || {}
    const { userIsLoggedIn = false, userIsSubscribed = false } = window.wsum || {}
    window.admiral('targeting', 'set', 'tags', tags)
    window.admiral('targeting', 'set', 'userIsLoggedIn', userIsLoggedIn ? '1' : '0')
    window.admiral('targeting', 'set', 'userIsSubscribed', userIsSubscribed ? '1' : '0')
  }
}

const component = {
  init() {
    return new Admiral()
  },
}

export default component
